import { Component } from "react";
import { useNavigate } from "react-router-dom";

import BillService from "../services/Bill";
import InfoAlert from "../components/layouts/InfoAlert";
import UtilsFormule from "../utils/UtilsFormule";


class Bills extends Component {
  formatDate(date) {
    let day = date.substring(8, 10);
    let month = date.substring(5, 7);
    let year = date.substring(0, 4);

    return day + "/" + month + "/" + year;
  }
  refreshPage() {
    window.location.reload();
  }
  deleteBill(idBill) {
    BillService.supprimerBill(idBill)
      .then((response) => {
        console.log("response", response.data["BC"]);
        if (response.data["Bill"] === "not deleted") {
          this.setState({ alert_message: "error" });
        } else {
          this.setState({ alert_message: "success" });
          this.refreshPage();
        }
      })
      .catch((error) => {
        //original   this.setState({ alert_message: "error" });
        this.setState({ alert_message: "success" });
        this.refreshPage();
      });
  }
  navigation() {
    const url = window.location.pathname.split("/")[1];

    if (url === "listBillVente") {
      this.props.navigate("/payerBillVente");
    } else if (url === "listBillAchat") {
      this.props.navigate("/payerBill");
    }
  }

  render() {
    return (
      <div class="col-md-12">
        <div className="card card-dark">
          <div className="card-header">
            <h3 className="card-title">{this.props.msg}</h3>
          </div>
          <div className="card-body">
            <table id="example1" className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Facture</th>
                  <th>Société </th>
                  <th>Date de création </th>
                  <th>Prix total de la facture </th>
                  <th>Payer</th>
                </tr>
              </thead>
              {this.props.bills.length > 0 ? (
                <tbody>
                  {this.props.bills.map((bill) => (
                    <tr>
                      <td>{bill.documentReference}- {bill.documentTitle}</td>
                      {bill.title ? (
                        <td> {bill.title}</td>
                      ) : (
                        <></>
                      )}

                      {bill.supplierMatricule ? (
                        <td> {bill.supplierMatricule}</td>
                      ) : (
                        <></>
                      )}
                      <td> {UtilsFormule.formatDateHours(bill.creationDate)}</td>

                      {bill.purchasingPrice && (
                        <td> {bill.purchasingPrice} </td>
                      )}
                      {bill.price_tt && <td> {bill.price_tt} </td>}
                      {bill.isPayed === 0 ? (
                        <td className="text-center">
                          <a
                            onClick={() => {
                              this.navigation();
                              localStorage.setItem("idBill", bill.idDocument);
                              localStorage.setItem("isPayed", "0");
                            }}
                          >
                            <span
                              className="badge bg-primary"
                              style={{ cursor: "pointer" }}
                            >
                              Payer
                            </span>{" "}
                          </a>
                        </td>
                      ) : (
                        <td className="text-center">
                          <a
                            onClick={() => {
                              this.navigation();
                              localStorage.setItem("idBill", bill.idDocument);
                              localStorage.setItem("isPayed", "1");
                            }}
                          >
                            <span
                              className="badge bg-success"
                              style={{ cursor: "pointer", color: "" }}
                            >
                              Payée
                            </span>{" "}
                          </a>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  {" "}
                  <tr>
                    <td></td>
                    <td></td>
                    <td style={{ textAlign: "center" }}> Aucun Résultat</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              )}
            </table>

            <br />
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export function BillsWithRoute(props) {
  const navigate = useNavigate();

  return (
    <Bills
      navigate={navigate}
      bills={props.bills}
      msg={props.msg}
      msgEmpty={props.msgEmpty}
      type={props.type}
    >
      {" "}
    </Bills>
  );
}
export default Bills;
